import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { CUSTOM_MASK } from '@helpers/custom-validator';
import { USA_COUNTRY_CODE } from '@constants/constants';

@Component({
  selector: 'app-marine-insurance-from-to-form',
  templateUrl: './marine-insurance-from-to-form.component.html',
  styleUrls: ['./marine-insurance-from-to-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MarineInsuranceFromToFormComponent {
  @Input() public countryFormControl: UntypedFormControl;
  @Input() public stateFormControl: UntypedFormControl;
  @Input() public cityFormControl: UntypedFormControl;
  @Input() public isHideState: boolean;

  public CUSTOM_MASK: typeof CUSTOM_MASK = CUSTOM_MASK;
  public defaultErrors: { [name: string]: string } = { required: 'FORM_ERROR.REQUIRED' };

  constructor(private cdr: ChangeDetectorRef) {}

  public updateInputsValidation(): void {
    this.cdr.markForCheck();
  }

  public resetStateValValidation(): void {
    this.stateFormControl?.reset();
    this.cdr.markForCheck();
  }

  public get defaultCountry(): string {
    return !this.isHideState ? USA_COUNTRY_CODE : null;
  }

  public get isDisabledCountry(): boolean {
    return !this.isHideState;
  }
}
